import React, { useMemo } from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import { BootstrapVerticalColumnTable } from '@components/Table/Table';
import { Page500 } from '@containers/ErrorPages';
import { userApi } from '@reducers/user/user';

export const UserGeneral = () => {
  const { data, isLoading, isError } = userApi.useGetDetailsQuery();

  const renderPasswordCell = () => (
    <Button as={Link} to="/settings/password/change" variant="didxl" size="sm">
      Change
    </Button>
  );

  const leftColumns = useMemo(
    () => [
      {
        Header: 'Company Name',
        accessor: 'company_name',
      },
      {
        Header: 'Address',
        accessor: 'address',
      },
      {
        Header: 'City',
        accessor: 'city',
      },
      {
        Header: 'Postal code',
        accessor: 'postal_code',
      },
      {
        Header: 'Website',
        accessor: 'website',
      },
      {
        Header: 'VAT number',
        accessor: 'vat_number',
      },
      {
        Header: 'Company reg. number',
        accessor: 'company_registration_number',
      },
      {
        Header: 'Timezone',
        accessor: 'timezone',
      },
    ],
    []
  );
  const rightColumns = useMemo(
    () => [
      {
        Header: 'Login',
        accessor: 'login',
      },
      {
        Header: 'Password',
        Cell: renderPasswordCell,
      },
      {
        Header: 'Currency',
        accessor: 'currency',
      },
      {
        Header: 'Customer Type',
        accessor: 'customer_type',
      },
      {
        Header: 'Channels',
        accessor: 'channels',
      },
      {
        Header: 'DIDs',
        accessor: 'dids_count',
      },
      {
        Header: 'Status',
        accessor: 'status',
      },
    ],
    []
  );

  if (isLoading) {
    return <DefaultSpinnerCenter />;
  }

  if (isError) {
    return <Page500 />;
  }

  return (
    <Row>
      <Col md={12}>
        <Card>
          <Card.Header className="bg-didxl text-white">
            General settings
          </Card.Header>
          <Card.Body>
            <Row>
              <Col md={6}>
                <BootstrapVerticalColumnTable
                  columns={leftColumns}
                  data={[data]}
                  tableProps={() => ({ responsive: true, bordered: true })}
                />
              </Col>
              <Col md={6}>
                <BootstrapVerticalColumnTable
                  columns={rightColumns}
                  data={[data]}
                  tableProps={() => ({ responsive: true, bordered: true })}
                />
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};
